import { RiskMapEditor } from "pages/Credit/components/RiskMapEditor"

export default function NewRiskMapping() {
  return <RiskMapEditor />
}
